var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form-button-disabler",
    [
      _vm.loaded
        ? _c(
            "field",
            {
              staticClass: "pb-2",
              attrs: {
                label: "Milestone Name",
                disabled: _vm.disabled,
                "error-text": _vm.showValidations ? _vm.validations.name : "",
              },
            },
            [
              _c("text-field", {
                model: {
                  value: _vm.updateMilestone.milestoneName,
                  callback: function ($$v) {
                    _vm.$set(_vm.updateMilestone, "milestoneName", $$v)
                  },
                  expression: "updateMilestone.milestoneName",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "field",
            {
              staticClass: "pb-2",
              attrs: {
                label: "Data As Of Date",
                "error-text": _vm.showValidations ? _vm.validations.date : "",
              },
            },
            [
              _c("date-field", {
                attrs: { format: "MM/dd/yyyy hh:mm a" },
                model: {
                  value: _vm.updateMilestone.asOfDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.updateMilestone, "asOfDate", $$v)
                  },
                  expression: "updateMilestone.asOfDate",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex pt-2" },
        [
          _c("div", { staticClass: "flex-grow" }),
          _vm._v(" "),
          _c(
            "btn",
            {
              on: {
                click: function ($event) {
                  return _vm.closeProp()
                },
              },
            },
            [_vm._v("Update")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }